// extracted by mini-css-extract-plugin
export default {"submit":"styleModule_submit__soynm"};